import { getBag } from '../helpers/reference-bags';

export const useApiCodeFromAccountId = (accountId, providerType) => {
  const { useSellerAccountHook, reduxReferenceKey, collection, cacheReferenceKey } = getBag(providerType);

  const sellerAccount = useSellerAccountHook(accountId);
  if (!sellerAccount) {
    return null;
  }

  const reference = collection?.find((p) => {
    return Number.parseInt(p[cacheReferenceKey], 10) === Number.parseInt(sellerAccount[reduxReferenceKey], 10);
  });

  return reference?.apiCode;
};
